import React from "react";
import PropTypes from "prop-types";
import { BorderlessCameraCard } from "orion-components/CBComponents";

const AlertCameraRows = ({ cameras, contextId, entityType, readOnly, alertDateTime, playbackStartOffset, recordedDuration }) => {
	const playerStyle = {
		minWidth: 0,
		width: "100%",
		aspectRatio: "16 / 9",
		overflow: "hidden"
	};

	return (
		<div style={{ display: "flex", flexDirection: "column", width: "100%", gap: 12 }}>
			{cameras.map(camera => (
				<div
					key={camera.id}
					style={{
						display: "grid",
						gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
						columnGap: 8,
						width: "100%",
						marginBottom: 12
					}}
					data-testid="alert-camera-row"
				>
					<div style={playerStyle} data-testid="alert-camera-live-player">
						<BorderlessCameraCard
							contextId={contextId}
							camera={camera}
							entityType={entityType}
							readOnly={readOnly}
							expanded={true}
							isOnAlertProfile={true}
							isOnProfile={true}
							alertDateTime={alertDateTime}
							defaultToRecorded={false}
							playbackStartOffset={playbackStartOffset}
							initialRecordedDuration={recordedDuration}
							initialRecordedTimeUnit="seconds"
							disableVideoModeToggle={true}
						/>
					</div>
					<div style={playerStyle} data-testid="alert-camera-recorded-player">
						<BorderlessCameraCard
							contextId={contextId}
							camera={camera}
							entityType={entityType}
							readOnly={readOnly}
							expanded={true}
							isOnAlertProfile={true}
							isOnProfile={true}
							alertDateTime={alertDateTime}
							defaultToRecorded={true}
							playbackStartOffset={playbackStartOffset}
							initialRecordedDuration={recordedDuration}
							initialRecordedTimeUnit="seconds"
							disableVideoModeToggle={true}
						/>
					</div>
				</div>
			))}
		</div>
	);
};

AlertCameraRows.propTypes = {
	cameras: PropTypes.arrayOf(PropTypes.object).isRequired,
	contextId: PropTypes.string.isRequired,
	entityType: PropTypes.string.isRequired,
	readOnly: PropTypes.bool,
	alertDateTime: PropTypes.any,
	playbackStartOffset: PropTypes.number,
	recordedDuration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

AlertCameraRows.defaultProps = {
	readOnly: false,
	alertDateTime: "",
	playbackStartOffset: 15
};

export default AlertCameraRows;
